import { render, staticRenderFns } from "./DisabilityAdd.vue?vue&type=template&id=39770a0b"
import script from "./DisabilityAdd.vue?vue&type=script&lang=js"
export * from "./DisabilityAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports